import savingGame from "./../../assets/our work/1.png";
import microGame from "./../../assets/our work/2.png";
import patrec from "./../../assets/our work/3.png";
import ecoEgypt from "./../../assets/our work/4.png";
import simTalant from "./../../assets/our work/5.png";
import apple from "./../../assets/our work/6.png";
import zido from "./../../assets/our work/zido.svg";
import Vatrina from "./../../assets/our work/Vatrina.png";
import zagg from "./../../assets/our work/zagg..png";
import roboost from "./../../assets/our work/roboost.png";
import Savvy from "./../../assets/our work/Savvy.png";
import abardo from "./../../assets/our work/abardo.png";
import jawalat from "./../../assets/our work/jawalat1.png";
import Historica from "./../../assets/our work/Historica.png";
import HistoricaR from "./../../assets/our work/historicaR.png";
import Graveler from "./../../assets/our work/Graveler.png";
import aiSports from "./../../assets/our work/aiSports.png";
import Wheels from "./../../assets/our work/Wheels.png";
import rabbit from "./../../assets/our work/rabbit.png";
import peacekeepers from "./../../assets/our work/peacekeepers.png";
import seeds_of_hope from "./../../assets/our work/seeds_of_hope.png";
import gam from "./../../assets/our work/gam.png";
import power from "./../../assets/our work/power.png";
import saqaya from "./../../assets/our work/saqaya.png";
import SAFY from "./../../assets/our work/SAFY.png";
import Saydaly from "./../../assets/our work/Saydaly.png";
import trips_large from "./../../assets/our work/trips_small.png";
import mrb_small from "./../../assets/our work/mrb_small.png";

export const categoriesProjects = [
  {
    name: "All",
    projects: [
      {
        id: "microGame",
        Image: microGame,
        name: "The Micro Business Game",
        subTitle: "Manage your juicery shop",
        text: "Client:  DSIK - German Ministry of Economic Cooperation",
        icon1: null,
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `0`,
      },

      {
        id: "savingGame",
        Image: savingGame,
        name: "The Savings Game",
        subTitle: "Manage your family household",
        text: " Client: DSIK - German Ministry of Economic Cooperation",
        icon1: null,
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `1`,
      },
      {
        id: "Jawalat Al Horouf",
        Image: jawalat,
        name: "Jawalat Al Horouf",
        subTitle: "(In Production)",
        text: "Client: Dubai Media Inc. - Dubai Government",
        icon1: "fas fa-mobile-alt",
        icon2: null,
        type: "Type: Platform",
        linkTo: `2`,
        withBigPadding: true,
      },
      {
        id: "ZidoWorldGames",
        Image: zido,
        name: "Zido World Games",
        subTitle: "Educational Game",
        text: "Client: ZAD group",
        icon1: "",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `3`,
      },
      {
        id: "Secrets of The Mountains",
        Image: Historica,
        name: "Secrets of The Mountains",
        subTitle: "(Pre Production)",
        text: "Client: Phantasm (Self Published)",
        icon1: "fas fa-desktop",
        icon2: null,
        image: gam,
        type: "Type: Platform",
        linkTo: `4`,
        withBigPadding: true,
      },
      {
        id: "patrec",
        Image: patrec,
        name: "PatRec",
        subTitle: "Digital Medical Consultation Platform",
        text: " Client: Holden Knight Group",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform ",
        linkTo: `5`,
      },
      {
        id: "ABARDO",
        Image: abardo,
        name: "ABARDO",
        subTitle: "Virtual and hybrid event experiences",
        text: "Client: Holden Knight Group",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform ",
        linkTo: `6`,
        withBigPadding: true,
      },
      {
        id: "Tayar",
        Image: roboost,
        name: "Tayar (Roboost)",
        subTitle: "AI-enabled delivery optimization system",
        text: "Top potential start up in MENA Raised $3M on a $30M valuation",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `7`,
        withBigPadding: true,
      },
      {
        id: "simTalant",
        Image: simTalant,
        name: "SIMTalent",
        subTitle: "Digital HR Training Platform",
        text: "Client: CELEMI ",
        icon1: "fas fa-desktop",
        icon2: null,
        type: "Type: Platform ",
        linkTo: `8`,
      },
      {
        id: "apple",
        Image: apple,
        name: "Apples and Oranges",
        subTitle: "Digital Corporate Training Platform",
        text: "Client: CELEMI ",
        icon1: "fas fa-desktop",
        icon2: null,
        type: "Type: Platform ",
        linkTo: `9`,
      },
      {
        id: "ecoEgypt",
        Image: ecoEgypt,
        name: "Eco Egypt",
        subTitle: "Digital Ecotourism and Conservation Platform",
        text: " Client: UNDP - The Ministry of Environment in Egypt (EEAA) - Wali’s Studio",
        icon1: "fas fa-desktop",
        icon2: null,
        type: "Type: Website AR experience",
        linkTo: `10`,
      },
      {
        id: "Vatrina",
        Image: Vatrina,
        name: "Vatrina",
        subTitle: "E-Commerce (B2B) & (B2C)",
        text: "Client: Vatrina",
        icon1: "fas fa-desktop",
        icon2: null,
        type: "Type: Platform",
        linkTo: `11`,
        withBigPadding: true,
      },
      {
        id: "ZAGG",
        Image: zagg,
        name: "ZAGG",
        subTitle: "E-Commerce",
        text: "Client: ZAGG",
        icon1: "fas fa-desktop",
        icon2: null,
        type: "Type: Platform",
        linkTo: `12`,
      },
      {
        id: "Saqaya",
        Image: saqaya,
        name: "Saqaya",
        subTitle: "",
        text: "Client: SAQAYA",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `13`,
        withBigPadding: true,
      },
      {
        id: "Pacific mining",
        Image: SAFY,
        name: "Pacific Mining",
        subTitle: "Raw Material Mining",
        text: "Client: Al Safy Group",
        icon1: "fas fa-desktop",
        icon2: "",
        type: "Type: Platform",
        linkTo: `14`,
        withBigPadding: true,
      },

      {
        id: "ZAGG",
        Image: zagg,
        name: "ZAGG",
        subTitle: "Staffing",
        text: "Client: ZAGG",
        icon1: "fas fa-desktop",
        icon2: null,
        type: "Type: Platform",
        linkTo: `15`,
      },
      {
        id: "AI Sports Data collection",
        Image: aiSports,
        name: "AI Sports Data collection",
        subTitle: "Brentford player data set and performance prediction tool",
        text: "Client: BRENTFORD - SAQAYA",
        icon1: null,
        icon2: null,
        type: "",
        linkTo: `16`,
        withBigPadding: true,
      },
      {
        id: "Savvy broker",
        Image: Savvy,
        name: "Savvy broker",
        subTitle: "Real estate",
        text: "Client: Beach landing - SAQAYA",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `17`,
        withBigPadding: true,
      },
      {
        id: "Saydaly",
        Image: Saydaly,
        name: "Saydaly",
        subTitle: "Pharmaceutical",
        text: "",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `18`,
        withBigPadding: true,
      },
      {
        id: "Noopets",
        Image: trips_large,
        name: "Noopets",
        subTitle: "Pet Delivery",
        text: "",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `19`,
        // withBigPadding: true,
        // withBigPadding: true,
      },
      {
        id: "MR.B",
        Image: mrb_small,
        name: "MR. B",
        subTitle: "Fleet Management",
        text: "",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `20`,
        // withBigPadding: true,
        // withBigPadding: true,
      },
      {
        id: "Seeds of Hope (بذور الأمل)",
        Image: seeds_of_hope,
        name: "Seeds of Hope (بذور الأمل)",
        subTitle: "(Concept)",
        text: "Potential Client: Potential Humanitarian Aid & Relief Centers",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        image: gam,
        type: "Type: Platform",
        linkTo: `21`,
        withBigPadding: true,
      },
      {
        id: "Graveler",
        Image: Graveler,
        name: "Graveler",
        subTitle: "Virtual University Campus",
        text: "Client: University of Tubingen",
        icon1: "fas fa-desktop",
        icon2: null,
        type: "Type: Platform",
        linkTo: `22`,
        // Graveler: true,
      },

      {
        id: "Historica",
        Image: HistoricaR,
        name: "Historica",
        subTitle: "(Pre Production)",
        text: "Potential Client:  Governmental Entities - Educational Institutions",
        icon1: "fas fa-mobile-alt",
        icon2: null,
        type: "Type: Platform",
        linkTo: `23`,
        withBigPadding: true,
      },
      {
        id: "PeaceKeepers",
        Image: peacekeepers,
        name: "PeaceKeepers",
        subTitle: "(Concept)",
        text: "Potential Client: NGOs and International Law bodies",
        icon1: "",
        icon2: "fas fa-mobile-alt",
        image: null,
        type: "Type: Platform",
        linkTo: `24`,
        withBigPadding: true,
      },
      {
        id: "Rabbit Rider",
        Image: rabbit,
        name: "Rabbit Rider",
        subTitle: "(Concept)",
        text: "Potential Client: Q-Commerce",
        icon1: "",
        icon2: "fas fa-mobile-alt",
        image: null,
        type: "Type: Platform",
        linkTo: `25`,
        withBigPadding: true,
      },
      {
        id: "Power Your Connection",
        Image: power,
        name: "Power Your Connection",
        subTitle: "(Concept - VR Experience)",
        text: "Potential Client: Retail stores",
        icon1: "",
        icon2: "fas fa-mobile-alt",
        image: null,
        type: "Type: Platform",
        linkTo: `26`,
        withBigPadding: true,
      },
      {
        id: "Wheels n Wings",
        Image: Wheels,
        name: "Wheels n Wings",
        subTitle: "(Concept)",
        text: "Potential Client: FMCGS",
        icon1: "",
        icon2: "fas fa-mobile-alt",
        image: null,
        type: "Type: Platform",
        linkTo: `27`,
        withBigPadding: true,
      },
    ],
  },
  {
    name: "Serious Games",
    projects: [
      {
        id: "microGame",
        Image: microGame,
        name: "The Micro Business Game",
        subTitle: "Manage your juicery shop",
        text: "Client:  DSIK - German Ministry of Economic Cooperation",
        icon1: null,
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `0`,
      },
      {
        id: "savingGame",
        Image: savingGame,
        name: "The Savings Game",
        subTitle: "Manage your family household",
        text: " Client:  DSIK - German Ministry of Economic Cooperation",
        icon1: null,
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `1`,
      },
      {
        id: "ZidoWorldGames",
        Image: zido,
        name: "Zido World Games",
        subTitle: "Educational Game",
        text: "Client: ZAD group",
        icon1: "",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform ",
        linkTo: `3`,
      },
    ],
  },
  {
    name: "Entertainment Games",
    projects: [
      {
        id: "Jawalat Al Horouf",
        Image: jawalat,
        name: "Jawalat Al Horouf",
        subTitle: "(In Production)",
        text: "Client: Dubai Media Inc. - Dubai Government",
        icon1: "fas fa-mobile-alt",
        icon2: null,
        type: "Type: Platform",
        linkTo: `2`,
        withBigPadding: true,
      },
      {
        id: "Secrets of The Mountains",
        Image: Historica,
        name: "Secrets of The Mountains",
        subTitle: "(Pre Production)",
        text: "Client: Phantasm (Self Published)",
        icon1: "fas fa-desktop",
        icon2: null,
        image: gam,
        type: "Type: Platform",
        linkTo: `4`,
        withBigPadding: true,
      },
    ],
  },

  {
    name: "Digital Solutions",
    projects: [
      {
        id: "patrec",
        Image: patrec,
        name: "PatRec",
        subTitle: "Digital Medical Consultation Platform",
        text: " Client: Holden Knight Group",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform ",
        linkTo: `5`,
      },
      {
        id: "ABARDO",
        Image: abardo,
        name: "ABARDO",
        subTitle: "Virtual and hybrid event experiences",
        text: "Client: Holden Knight Group",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform ",
        linkTo: `6`,
        withBigPadding: true,
      },
      {
        id: "Tayar",
        Image: roboost,
        name: "Tayar (Roboost)",
        subTitle: "AI-enabled delivery optimization system",
        text: "Top potential start up in MENA Raised $3M on a $30M valuation",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `7`,
        withBigPadding: true,
      },
      {
        id: "simTalant",
        Image: simTalant,
        name: "SIMTalent",
        subTitle: "Digital HR Training Platform",
        text: "Client: CELEMI ",
        icon1: "fas fa-desktop",
        icon2: null,
        type: "Type: Platform ",
        linkTo: `8`,
      },
      {
        id: "apple",
        Image: apple,
        name: "Apples and Oranges",
        subTitle: "Digital Corporate Training Platform",
        text: "Client: CELEMI ",
        icon1: "fas fa-desktop",
        icon2: null,
        type: "Type: Platform ",
        linkTo: `9`,
      },
      {
        id: "ecoEgypt",
        Image: ecoEgypt,
        name: "EcoEgypt",
        subTitle: "Digital Ecotourism and Conservation Platform",
        text: "Client: UNDP / The Ministry of Environment in Egypt - EEAA/ Wali’s Studio ",
        icon1: "fas fa-desktop",
        icon2: null,
        type: "Type: Platform ",
        linkTo: `10`,
      },

      {
        id: "Vatrina",
        Image: Vatrina,
        name: "Vatrina",
        subTitle: "E-Commerce (B2B) & (B2C)",
        text: "Client: Vatrina",
        icon1: "fas fa-desktop",
        icon2: null,
        type: "Type: Platform",
        linkTo: `11`,
        withBigPadding: true,
      },
      {
        id: "ZAGG",
        Image: zagg,
        name: "ZAGG",
        subTitle: "E-Commerce",
        text: "Client: ZAGG",
        icon1: "fas fa-desktop",
        icon2: null,
        type: "Type: Platform",
        linkTo: `12`,
      },
      {
        id: "Saqaya",
        Image: saqaya,
        name: "Saqaya",
        subTitle: "",
        text: "Client: SAQAYA",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `13`,
        withBigPadding: true,
      },
      {
        id: "Pacific mining",
        Image: SAFY,
        name: "Pacific Mining",
        subTitle: "Raw Material Mining",
        text: "Client: Al Safy Group",
        icon1: "fas fa-desktop",
        icon2: "",
        type: "Type: Platform",
        linkTo: `14`,
        withBigPadding: true,
      },
    ],
  },

  {
    name: "Staffing ",
    projects: [
      {
        id: "ZAGG",
        Image: zagg,
        name: "ZAGG",
        subTitle: "Staffing",
        text: "Client: ZAGG",
        icon1: "fas fa-desktop",
        icon2: null,
        type: "Type: Platform",
        linkTo: `15`,
      },
      {
        id: "AI Sports Data collection",
        Image: aiSports,
        name: "AI Sports Data collection",
        subTitle: "Brentford player data set and performance prediction tool",
        text: "Client: BRENTFORD - SAQAYA",
        icon1: null,
        icon2: null,
        type: "",
        linkTo: `16`,
        withBigPadding: true,
      },
      {
        id: "Savvy broker",
        Image: Savvy,
        name: "Savvy broker",
        subTitle: "Real estate",
        text: "Client: Beach landing - SAQAYA",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `17`,
        withBigPadding: true,
      },
    ],
  },
  {
    name: "Onshelf solutions",
    projects: [
      {
        id: "Saydaly",
        Image: Saydaly,
        name: "Saydaly",
        subTitle: "Pharmaceutical",
        text: "",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `18`,
        withBigPadding: true,
      },
      {
        id: "Noopets",
        Image: trips_large,
        name: "Noopets",
        subTitle: "Pet Delivery",
        text: "",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `19`,
        // withBigPadding: true,
        // withBigPadding: true,
      },
      {
        id: "MR.B",
        Image: mrb_small,
        name: "MR. B",
        subTitle: "Fleet Management",
        text: "",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        type: "Type: Platform",
        linkTo: `20`,
        // withBigPadding: true,
        // withBigPadding: true,
      },
    ],
  },

  {
    name: "Concepts & Sketches ",
    projects: [
      {
        id: "Seeds of Hope (بذور الأمل)",
        Image: seeds_of_hope,
        name: "Seeds of Hope (بذور الأمل)",
        subTitle: "(Concept)",
        text: "Potential Client: Potential Humanitarian Aid & Relief Centers",
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        image: gam,
        type: "Type: Platform",
        linkTo: `21`,
        withBigPadding: true,
      },
      {
        id: "Graveler",
        Image: Graveler,
        name: "Graveler",
        subTitle: "Virtual University Campus",
        text: "Client: University of Tubingen",
        icon1: "fas fa-desktop",
        icon2: null,
        type: "Type: Platform",
        linkTo: `22`,
        Graveler: true,
      },
      {
        id: "Historica",
        Image: HistoricaR,
        name: "Historica",
        subTitle: "(Pre Production) ",
        text: "Potential Client:  Governmental Entities - Educational Institutions",
        icon1: "fas fa-mobile-alt",
        icon2: null,
        type: "Type: Platform",
        linkTo: `23`,
        withBigPadding: true,
      },
      {
        id: "PeaceKeepers",
        Image: peacekeepers,
        name: "PeaceKeepers",
        subTitle: "(Concept)",
        text: "Potential Client: NGOs and International Law bodies",
        icon1: "",
        icon2: "fas fa-mobile-alt",
        image: null,
        type: "Type: Platform",
        linkTo: `24`,
        withBigPadding: true,
      },
      {
        id: "Rabbit Rider",
        Image: rabbit,
        name: "Rabbit Rider",
        subTitle: "(Concept)",
        text: "Potential Client: Q-Commerce",
        icon1: "",
        icon2: "fas fa-mobile-alt",
        image: null,
        type: "Type: Platform",
        linkTo: `25`,
        withBigPadding: true,
      },
      {
        id: "Power Your Connection",
        Image: power,
        name: "Power Your Connection",
        subTitle: "(Concept - VR Experience)",
        text: "Potential Client: Retail stores",
        icon1: "",
        icon2: "fas fa-mobile-alt",
        image: null,
        type: "Type: Platform",
        linkTo: `26`,
        withBigPadding: true,
      },
      {
        id: "Wheels n Wings",
        Image: Wheels,
        name: "Wheels n Wings",
        subTitle: "(Concept)",
        text: "Potential Client: FMCGS",
        icon1: "",
        icon2: "fas fa-mobile-alt",
        image: null,
        type: "Type: Platform",
        linkTo: `27`,
        withBigPadding: true,
      },
    ],
  },
];
